import { useFlags, useFlagsmithLoading, useFlagsmith, FlagsmithProvider } from 'flagsmith/react';
import flagsmith from 'flagsmith';
import { jsx } from 'react/jsx-runtime';

var useFeatureFlags = function(flagNames) {
    var flags = useFlags(flagNames);
    return flagNames.map(function(flagNames) {
        return flags[flagNames];
    });
};

var RequireFeatureFlag = function(param) {
    var featureFlag = param.featureFlag, _param_noFlagElement = param.noFlagElement, noFlagElement = _param_noFlagElement === void 0 ? null : _param_noFlagElement, children = param.children;
    var flagsmithLoadingState = useFlagsmithLoading();
    var flags = useFeatureFlags([
        featureFlag
    ]);
    if (flagsmithLoadingState === null || flagsmithLoadingState === void 0 ? void 0 : flagsmithLoadingState.isLoading) ;
    return flags.length && flags[0].enabled ? children : noFlagElement;
};

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var defaultFlagMap = new Map([
    [
        "account_popup_enabled",
        {
            enabled: true
        }
    ],
    [
        "cashouts_view_enabled",
        {
            enabled: true
        }
    ],
    [
        "channel_passes",
        {
            enabled: true
        }
    ],
    [
        "channel_trailer",
        {
            enabled: true
        }
    ],
    [
        "channel_web_routing_for_embedded_enabled",
        {
            enabled: false
        }
    ],
    [
        "decouple_player",
        {
            enabled: false
        }
    ],
    [
        "disable_media_api_follow_sync",
        {
            enabled: true
        }
    ],
    [
        "disable_referral_bouns",
        {
            enabled: true
        }
    ],
    [
        "embedded_preview",
        {
            enabled: true
        }
    ],
    [
        "enable_account_password_reset",
        {
            enabled: true
        }
    ],
    [
        "enable_account_wallet_lozenge",
        {
            enabled: true
        }
    ],
    [
        "enable_auth_outbox_events",
        {
            enabled: true
        }
    ],
    [
        "enable_auth_user_check_on_referrer_bonus",
        {
            enabled: true
        }
    ],
    [
        "enable_auto_start",
        {
            enabled: true
        }
    ],
    [
        "enable_business_app_base",
        {
            enabled: false
        }
    ],
    [
        "enable_channel_config_anonymised_data",
        {
            enabled: true
        }
    ],
    [
        "enable_channel_config_data_download",
        {
            enabled: true
        }
    ],
    [
        "enable_channel_config_tier_selection",
        {
            enabled: true
        }
    ],
    [
        "enable_channel_events_purchase_api_consumer",
        {
            enabled: true
        }
    ],
    [
        "enable_channel_passes",
        {
            enabled: true
        }
    ],
    [
        "enable_clip_upload_via_video_api",
        {
            enabled: true
        }
    ],
    [
        "enable_comments",
        {
            enabled: false
        }
    ],
    [
        "enable_comments_role",
        {
            enabled: false
        }
    ],
    [
        "enable_country_validate_email",
        {
            enabled: true
        }
    ],
    [
        "enable_default_widget_styles",
        {
            enabled: false
        }
    ],
    [
        "enable_double_transaction_prevention_lock",
        {
            enabled: false
        }
    ],
    [
        "enable_fan_tab",
        {
            enabled: true
        }
    ],
    [
        "enable_geoblock_query_param",
        {
            enabled: true
        }
    ],
    [
        "enable_ledger_events_purchase_api_consumer",
        {
            enabled: true
        }
    ],
    [
        "enable_mandatory_recaptcha",
        {
            enabled: false
        }
    ],
    [
        "enable_max_transcode_resolution_option",
        {
            enabled: true
        }
    ],
    [
        "enable_new_event_tables",
        {
            enabled: true
        }
    ],
    [
        "enable_new_recommended_pricing",
        {
            enabled: true
        }
    ],
    [
        "enable_new_vendor_terms_and_conditions",
        {
            enabled: true
        }
    ],
    [
        "enable_new_video_tables",
        {
            enabled: true
        }
    ],
    [
        "enable_new_wallet_api_error_codes",
        {
            enabled: true
        }
    ],
    [
        "enable_outbox_event_profile_api",
        {
            enabled: true
        }
    ],
    [
        "enable_outbox_events",
        {
            enabled: true
        }
    ],
    [
        "enable_outbox_listings_events",
        {
            enabled: true
        }
    ],
    [
        "enable_package_details_in_channel_config_events",
        {
            enabled: true
        }
    ],
    [
        "enable_profile_deletion_and_user_deletion_events",
        {
            enabled: true
        }
    ],
    [
        "enable_publisher_meilisearch_tariff_indexing",
        {
            enabled: false
        }
    ],
    [
        "enable_publisher_outbox_events",
        {
            enabled: true
        }
    ],
    [
        "enable_purchase_events_purchase_api_producer",
        {
            enabled: true
        }
    ],
    [
        "enable_purchase_refunds",
        {
            enabled: true
        }
    ],
    [
        "enable_purchase_v1",
        {
            enabled: true
        }
    ],
    [
        "enable_purchased_content_check",
        {
            enabled: true
        }
    ],
    [
        "enable_recast_country_check",
        {
            enabled: true
        }
    ],
    [
        "enable_recurly_signup_flow",
        {
            enabled: true
        }
    ],
    [
        "enable_refund_stats",
        {
            enabled: true
        }
    ],
    [
        "enable_single_nodejs_process_on_wallet",
        {
            enabled: true
        }
    ],
    [
        "enable_tariff_status_check_for_token_generation",
        {
            enabled: true
        }
    ],
    [
        "enable_video_events_purchase_api_consumer",
        {
            enabled: true
        }
    ],
    [
        "enable_video_listings_events",
        {
            enabled: true
        }
    ],
    [
        "enable_vod_transcode_interruptions",
        {
            enabled: false
        }
    ],
    [
        "enable_wallet_outbox_events",
        {
            enabled: true
        }
    ],
    [
        "enable_warn_about_geoblock",
        {
            enabled: true,
            options: {
                json: true,
                fallback: [
                    "5OBLQ"
                ]
            }
        }
    ],
    [
        "feature_account_notification_settings",
        {
            enabled: false
        }
    ],
    [
        "live_chat_autoload",
        {
            enabled: true,
            options: {
                json: true,
                fallback: {
                    channelIds: [
                        "8dA1o"
                    ]
                }
            }
        }
    ],
    [
        "my_data_wallet_2",
        {
            enabled: true,
            options: {
                json: true,
                fallback: [
                    {
                        uid: "8PBZx",
                        link: "https://store.inter.it/en-gb/legal-area/privacy-policy.html"
                    },
                    {
                        uid: "8XBy2",
                        link: "https://www.canoeicf.com/sites/default/files/icf_privacy_policy_230623.pdf"
                    },
                    {
                        uid: "8eADz",
                        link: "https://www.scottishfa.co.uk/privacy-notice"
                    }
                ]
            }
        }
    ],
    [
        "partner_web_min_pricing",
        {
            enabled: true
        }
    ],
    [
        "publisher_meilisearch_indexing",
        {
            enabled: true
        }
    ],
    [
        "remove_video_card_watch_button",
        {
            enabled: false,
            options: {
                json: false,
                fallback: {
                    remove: false
                }
            }
        }
    ],
    [
        "request_cashout_button",
        {
            enabled: true
        }
    ],
    [
        "signup_providers",
        {
            enabled: false,
            options: {
                json: true,
                fallback: [
                    "google",
                    "facebook"
                ]
            }
        }
    ],
    [
        "tariff_meilisearch_indexing",
        {
            enabled: true
        }
    ],
    [
        "use_automatic_stream_failover",
        {
            enabled: false
        }
    ],
    [
        "tariff_meilisearch_indexing",
        {
            enabled: true
        }
    ],
    [
        "use_events_for_stream_init",
        {
            enabled: true
        }
    ],
    [
        "use_fastly_for_live",
        {
            enabled: true
        }
    ],
    [
        "use_inventory_service_with_current_flow",
        {
            enabled: false
        }
    ],
    [
        "use_play_from_start",
        {
            enabled: true
        }
    ],
    [
        "use_recast_live",
        {
            enabled: true
        }
    ],
    [
        "userpilot",
        {
            enabled: true
        }
    ]
]);
var defaultFlags = Object.keys(defaultFlagMap).reduce(function(acc, key) {
    var _value_options;
    var value = defaultFlagMap.get(key);
    var _value_enabled;
    return _object_spread_props(_object_spread({}, acc), _define_property({}, key, {
        enabled: (_value_enabled = value === null || value === void 0 ? void 0 : value.enabled) !== null && _value_enabled !== void 0 ? _value_enabled : false,
        value: value === null || value === void 0 ? void 0 : (_value_options = value.options) === null || _value_options === void 0 ? void 0 : _value_options.fallback
    }));
}, {});

function useFeatureFlagValue(flag) {
    var flagsmith = useFlagsmith();
    var flagDefault = defaultFlagMap.get(flag);
    return flagDefault ? flagsmith.getValue(flag, flagDefault.options) : undefined;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var initFlags = function() {
    var _ref = _async_to_generator(function(config) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    cleanUpBrokenCache(config.onError);
                    return [
                        4,
                        flagsmith.init({
                            api: config.apiUrl,
                            cacheFlags: true,
                            defaultFlags: defaultFlags,
                            environmentID: config.environmentId,
                            evaluationContext: config.evaluationContext,
                            onChange: config.onChange,
                            onError: config.onError
                        })
                    ];
                case 1:
                    _state.sent();
                    flagsmith.startListening(config.pollingInterval);
                    return [
                        2
                    ];
            }
        });
    });
    return function initFlags(config) {
        return _ref.apply(this, arguments);
    };
}();
function cleanUpBrokenCache(onError) {
    try {
        var _window_localStorage_getItem;
        var cache = JSON.parse((_window_localStorage_getItem = window.localStorage.getItem("BULLET_TRAIN_DB")) !== null && _window_localStorage_getItem !== void 0 ? _window_localStorage_getItem : "null");
        if (cache.evaluationContext.identity && !cache.evaluationContext.identity.identifier) {
            window.localStorage.removeItem("BULLET_TRAIN_DB");
        }
    } catch (e) {
        onError === null || onError === void 0 ? void 0 : onError(e);
    }
}

var identifyUser = function(identifier, traits) {
    return flagsmith.setContext({
        identity: {
            identifier: identifier,
            traits: traits
        }
    });
};

var identifyUserStop = function() {
    return flagsmith.logout();
};

var getHasFeature = function(featureFlagName) {
    return flagsmith.hasFeature(featureFlagName);
};

var FlagProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ jsx(FlagsmithProvider, {
        flagsmith: flagsmith,
        children: children
    });
};

export { FlagProvider, RequireFeatureFlag, getHasFeature, identifyUser, identifyUserStop, initFlags, useFeatureFlagValue, useFeatureFlags };
